export const videos = [
  {
    id: 'v-2001',
    title: '光影纪年：一部电影的诞生全纪录',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20abstract%20film%20production%20scene%20with%20clapperboard%20and%20camera%20silhouette%2C%20warm%20amber%20spotlight%20beams%2C%20deep%20red%20tones%2C%20moody%20professional%20atmosphere%2C%20clean%20dark%20background%20for%20text%20overlay&width=800&height=500&seq=video-film-01&orientation=landscape',
    duration: '12:48',
    type: 'film',
    typeName: '影视剧',
    category: 'film',
    categoryName: '影视新闻',
    description: '跟随剧组走进一部电影从剧本围读到杀青的完整历程，记录那些台前幕后的真实瞬间。',
    uploadDate: '2026-10-14',
    views: 214300,
    tags: ['幕后', '电影', '纪实'],
    featured: true,
  },
  {
    id: 'v-2002',
    title: '舞台高光时刻：年度最佳表演合集',
    cover: 'https://readdy.ai/api/search-image?query=Vibrant%20abstract%20stage%20performance%20with%20warm%20orange%20and%20red%20lighting%2C%20dancers%20silhouettes%20in%20motion%2C%20energetic%20entertainment%20show%20atmosphere%2C%20cinematic%20composition%20with%20negative%20space&width=800&height=500&seq=video-variety-02&orientation=landscape',
    duration: '08:32',
    type: 'variety',
    typeName: '综艺',
    category: 'variety',
    categoryName: '综艺资讯',
    description: '精选年度综艺舞台上最出圈的高光表演片段，一次看遍才华与热情的碰撞。',
    uploadDate: '2026-10-13',
    views: 178920,
    tags: ['舞台', '高光', '综艺'],
    featured: true,
  },
  {
    id: 'v-2003',
    title: '城市夜色漫游：一支乐队的巡演日记',
    cover: 'https://readdy.ai/api/search-image?query=Atmospheric%20abstract%20night%20city%20scene%20with%20warm%20neon%20lights%2C%20musician%20silhouette%20with%20guitar%2C%20orange%20and%20red%20glow%2C%20cinematic%20mood%2C%20clean%20dark%20composition&width=800&height=500&seq=video-music-03&orientation=landscape',
    duration: '15:20',
    type: 'short',
    typeName: '短视频',
    category: 'music',
    categoryName: '音乐资讯',
    description: '用镜头记录一支乐队巡演路上的城市夜色与舞台之外的生活片段。',
    uploadDate: '2026-10-12',
    views: 98450,
    tags: ['音乐', '巡演', '城市'],
    featured: true,
  },
  {
    id: 'v-2004',
    title: '悬疑新剧第一集精华速览',
    cover: 'https://readdy.ai/api/search-image?query=Moody%20abstract%20suspense%20scene%20with%20fog%20and%20a%20single%20warm%20red%20light%2C%20mysterious%20doorway%20silhouette%2C%20dark%20cinematic%20tones%2C%20grained%20texture%2C%20minimal%20cover%20visual&width=800&height=500&seq=video-suspense-04&orientation=landscape',
    duration: '06:15',
    type: 'film',
    typeName: '影视剧',
    category: 'film',
    categoryName: '影视新闻',
    description: '热门悬疑剧首集精华速览，带你快速进入扑朔迷离的剧情世界。',
    uploadDate: '2026-10-11',
    views: 156780,
    tags: ['悬疑', '剧集', '速览'],
  },
  {
    id: 'v-2005',
    title: '十分钟看懂本届音乐盛典看点',
    cover: 'https://readdy.ai/api/search-image?query=Glamorous%20abstract%20award%20ceremony%20stage%20with%20warm%20gold%20and%20red%20lighting%2C%20glowing%20trophy%20silhouette%2C%20elegant%20cinematic%20atmosphere%2C%20clean%20dark%20backdrop&width=800&height=500&seq=video-awards-05&orientation=landscape',
    duration: '10:05',
    type: 'variety',
    typeName: '综艺',
    category: 'music',
    categoryName: '音乐资讯',
    description: '盘点本届音乐盛典的表演看点与颁奖瞬间，快速掌握全场高光。',
    uploadDate: '2026-10-10',
    views: 87460,
    tags: ['盛典', '看点', '颁奖'],
  },
  {
    id: 'v-2006',
    title: '独立短片计划：五分钟讲一个故事',
    cover: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20short%20film%20visual%20with%20warm%20amber%20gradients%2C%20lone%20figure%20silhouette%20walking%2C%20soft%20cinematic%20lighting%2C%20minimal%20elegant%20atmosphere%2C%20clean%20composition&width=800&height=500&seq=video-short-06&orientation=landscape',
    duration: '05:40',
    type: 'short',
    typeName: '短视频',
    category: 'film',
    categoryName: '影视新闻',
    description: '来自独立创作者的五分钟短片合集，用有限的时长讲述完整而动人的故事。',
    uploadDate: '2026-10-09',
    views: 64120,
    tags: ['短片', '独立', '叙事'],
  },
  {
    id: 'v-2007',
    title: '综艺幕后：一档节目是如何被做出来的',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20abstract%20TV%20studio%20control%20room%20with%20warm%20amber%20accent%20lights%2C%20monitors%20glow%2C%20professional%20behind-the-scenes%20atmosphere%2C%20clean%20dark%20composition&width=800&height=500&seq=video-backstage-07&orientation=landscape',
    duration: '14:02',
    type: 'variety',
    typeName: '综艺',
    category: 'variety',
    categoryName: '综艺资讯',
    description: '走进综艺节目幕后，了解一档节目从策划、录制到后期的完整制作流程。',
    uploadDate: '2026-10-08',
    views: 73280,
    tags: ['幕后', '综艺', '制作'],
  },
  {
    id: 'v-2008',
    title: '新专辑抢先听：三首歌带你认识她',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20abstract%20music%20visual%20with%20glowing%20sound%20waves%20and%20studio%20microphone%20silhouette%2C%20orange%20gradient%20lighting%2C%20elegant%20modern%20aesthetic%2C%20clean%20dark%20background&width=800&height=500&seq=video-album-08&orientation=landscape',
    duration: '09:18',
    type: 'short',
    typeName: '短视频',
    category: 'music',
    categoryName: '音乐资讯',
    description: '用三首歌的时间认识这位新生代歌手，感受专辑中不同风格的情绪表达。',
    uploadDate: '2026-10-07',
    views: 55940,
    tags: ['新专辑', '抢先听', '歌手'],
  },
  {
    id: 'v-2009',
    title: '红毯现场：年度盛典星光时刻',
    cover: 'https://readdy.ai/api/search-image?query=Glamorous%20abstract%20red%20carpet%20scene%20with%20warm%20gold%20spotlights%2C%20elegant%20arched%20entrance%20silhouette%2C%20luxurious%20cinematic%20atmosphere%2C%20rich%20red%20and%20amber%20tones%2C%20clean%20composition&width=800&height=500&seq=video-redcarpet-09&orientation=landscape',
    duration: '11:36',
    type: 'variety',
    typeName: '综艺',
    category: 'star',
    categoryName: '明星动态',
    description: '聚焦年度盛典红毯现场，记录明星亮相的每一个星光瞬间。',
    uploadDate: '2026-10-06',
    views: 192560,
    tags: ['红毯', '盛典', '星光'],
    featured: true,
  },
  {
    id: 'v-2010',
    title: '纪录片精选：小城的一天',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20nostalgic%20abstract%20small-town%20morning%20scene%2C%20soft%20orange%20sunrise%20over%20low%20buildings%2C%20gentle%20documentary%20mood%2C%20cinematic%20and%20clean%20with%20negative%20space&width=800&height=500&seq=video-town-10&orientation=landscape',
    duration: '22:14',
    type: 'film',
    typeName: '影视剧',
    category: 'film',
    categoryName: '影视新闻',
    description: '用一天的时间记录一座小城的日常，在平凡中感受真实的生活质感。',
    uploadDate: '2026-10-05',
    views: 41270,
    tags: ['纪录片', '生活', '真实'],
  },
  {
    id: 'v-2011',
    title: '即兴喜剧现场：笑点密集的三十分钟',
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20warm%20abstract%20comedy%20stage%20with%20a%20microphone%20silhouette%20and%20amber%20spotlight%2C%20deep%20shadows%2C%20intimate%20performance%20atmosphere%2C%20minimal%20elegant%20visual&width=800&height=500&seq=video-improv-11&orientation=landscape',
    duration: '18:50',
    type: 'variety',
    typeName: '综艺',
    category: 'variety',
    categoryName: '综艺资讯',
    description: '一场即兴喜剧的现场记录，看演员如何在没有剧本的情况下制造密集笑点。',
    uploadDate: '2026-10-04',
    views: 68930,
    tags: ['即兴', '喜剧', '现场'],
  },
  {
    id: 'v-2012',
    title: '经典片段重温：那些年打动我们的镜头',
    cover: 'https://readdy.ai/api/search-image?query=Nostalgic%20abstract%20retro%20cinema%20visual%20with%20film%20strip%20and%20warm%20amber%20glow%2C%20vintage%20yet%20modern%20aesthetic%2C%20red%20accents%2C%20clean%20dark%20background%20with%20negative%20space&width=800&height=500&seq=video-classic-12&orientation=landscape',
    duration: '16:08',
    type: 'film',
    typeName: '影视剧',
    category: 'film',
    categoryName: '影视新闻',
    description: '重温那些曾打动无数观众的经典镜头，感受影像跨越时间的魅力。',
    uploadDate: '2026-10-03',
    views: 113450,
    tags: ['经典', '重温', '镜头'],
  },
];